// Fill these in after cdk deploy outputs
export const config = {
  apiUrl: process.env.REACT_APP_API_URL ?? "",
  userPoolId: process.env.REACT_APP_USER_POOL_ID ?? "",
  userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID ?? "",
};
